import styled, { keyframes } from 'styled-components';

import { rgba } from 'polished';

const pulseCallSuccess = keyframes`
    0% {
        box-shadow: 0 0 0 0 ${({theme}) => rgba(theme.success, 0.6)};
    }
    70% {
        box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
    }
`;

const shake = keyframes`
    0% {
        transform: translate(0, 0);
    }
    1.25% {
        transform: translate(-2.5%, 0);
    }
    2.5% {
        transform: translate(0, 0);
    }
    3.75% {
        transform: translate(2.5%, 0);
    }
    5% {
        transform: translate(0, 0);
    }
    6.25% {
        transform: translate(-5%, 0);
    }
    7.5% {
        transform: translate(0, 0);
    }
    8.75% {
        transform: translate(5%, 0);
    }
    10% {
        transform: translate(0, 0);
    }
    11.25% {
        transform: translate(-5%, 0);
    }
    12.5% {
        transform: translate(0, 0);
    }
    13.75% {
        transform: translate(5%, 0);
    }
    15% {
        transform: translate(0, 0);
    }
    16.25% {
        transform: translate(-7.5%, 0);
    }
    17.5% {
        transform: translate(0, 0);
    }
    18.75% {
        transform: translate(7.5%, 0);
    }
    20% {
        transform: translate(0, 0);
    }
    21.25% {
        transform: translate(-7.5%, 0);
    }
    22.5% {
        transform: translate(0, 0);
    }
    23.75% {
        transform: translate(7.5%, 0);
    }
    25% {
        transform: translate(0, 0);
    }
    26.25% {
        transform: translate(-7.5%, 0);
    }
    27.5% {
        transform: translate(0, 0);
    }
    28.75% {
        transform: translate(7.5%, 0);
    }
    30% {
        transform: translate(0, 0);
    }
    31.25% {
        transform: translate(-7.5%, 0);
    }
    32.5% {
        transform: translate(0, 0);
    }
    33.75% {
        transform: translate(7.5%, 0);
    }
    35% {
        transform: translate(0, 0);
    }
    36.25% {
        transform: translate(-7.5%, 0);
    }
    37.5% {
        transform: translate(0, 0);
    }
    38.75% {
        transform: translate(7.5%, 0);
    }
    40% {
        transform: translate(0, 0);
    }
    41.25% {
        transform: translate(-7.5%, 0);
    }
    42.5% {
        transform: translate(0, 0);
    }
    43.75% {
        transform: translate(7.5%, 0);
    }
    45% {
        transform: translate(0, 0);
    }
    46.25% {
        transform: translate(-7.5%, 0);
    }
    47.5% {
        transform: translate(0, 0);
    }
    48.75% {
        transform: translate(7.5%, 0);
    }
    50% {
        transform: translate(0, 0);
    }
`;

export const PrimaryNavStyled = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${props => props.theme.mainColor1};
    @media only screen and (min-width: 600px) { width: 50px; }
    @media only screen and (min-width: 1700px) { width: 60px; }
    .logo{
        margin: 20px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
        position: relative;
        cursor: pointer;
        .loading-container{
            background-color: transparent!important;
        }
        img{
            max-width: 35px;
        }
    }
    .menu-secondary{
        position: relative;
        .group-item{
            position: relative;
        }
    }
    .menu{
        overflow: auto;
        padding-top: 3px;
    }
    .menu,
    .menu-secondary{
        display: flex;
        flex-direction: column;
        flex: 1;
        min-height: 0;
        min-width: 0;
        align-items: center;
        justify-content: flex-start;
        &-secondary{
            flex: none;
            margin-bottom: 5px;
        }
        .item{
            padding: 10px 0;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 250ms ease;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            cursor: pointer;
            flex-shrink: 0;
            margin-bottom: 10px;
            &.pulse-call{
                animation: ${pulseCallSuccess} 1s infinite;
                svg{
                    color: ${({ theme }) =>  theme.success}!important;
                    animation: ${shake} 1.5s cubic-bezier( 0.43, 0, 0.6, 0.4 ) infinite;
                }
            }
            &:last-child{
                margin-bottom: 0;
            }
            >*{
                display: flex;
            }
            &.active{
                background-color: ${({ theme }) =>  rgba(theme.white, 0.10)};
                svg{
                    color: ${({ theme }) => theme.white};
                }
            }
            &:hover{
                background-color: ${({ theme }) => rgba(theme.white, 0.10)}!important;
                .btn{
                    background-color: transparent!important;
                }
                svg{
                    color: ${({ theme }) => theme.white};
                }
                .tooltip{
                    transform: translate(110%,-50%);
                    opacity: 1;
                    visibility: visible;
                }
            }
            svg{
                width: 24px;
                height: 24px;
                color: ${({ theme }) => rgba(theme.white, 0.6)};
            }
        }
    }
`;
